
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { DeletedLinksTypeEnum } from '@api/api';
import { fetchAdScripts } from '@queries/useAdScripts';
import { fetchArticle } from '@queries/useArticle';
import { fetchCategoryArticles } from '@queries/useCategoryArticles';
import { fetchCategoryArticlesCount } from '@queries/useCategoryArticlesCount';
import { fetchGlobal } from '@queries/useGlobal';
import { fetchSlugs } from '@queries/useSlugs';
import { handleDeletedLink } from '@utils/handleDeletedLink';
import { buildArticleLink, buildCategoryPageLink } from '@utils/link';
import { isCategory, shouldHandleArticlePage } from '@utils/page';
import { buildResourceSeoSettings, getResourceSeo } from '@utils/seo';
import { GetStaticPaths, GetStaticProps } from 'next';
import dynamic from 'next/dynamic';
import { QueryClient, dehydrate } from 'react-query';

const CategoryPage = dynamic(
  () => import('@components/layout/PageContent/CategoryPage').then((mod) => mod.CategoryPage),
  { ssr: true },
);

export default function RedirectPage({ type, slug, seo }) {
  if (isCategory(type)) {
    return <CategoryPage slug={slug} seo={seo} />;
  }

  return null;
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    fallback: 'blocking',
    paths: [],
  };
};

 const _getStaticProps: GetStaticProps = async (context) => {
  const { slug } = context.params;
  const shouldRedirectToArticlePage = shouldHandleArticlePage(slug);

  if (shouldRedirectToArticlePage) {
    try {
      const article = await fetchArticle(String(slug));
      return {
        redirect: {
          destination: buildArticleLink(article.id, article.slug),
          permanent: true,
        },
        revalidate: 600,
      };
    } catch (e) {
      return {
        notFound: true,
        revalidate: 600,
      };
    }
  }

  try {
    const queryClient = new QueryClient();
    const slugs = [String(slug)];
    const [category = null] = await queryClient.fetchQuery(['links', slugs], async () =>
      fetchSlugs(slugs),
    );

    if (!category) {
      return await handleDeletedLink(DeletedLinksTypeEnum.Category, String(slug), (item) =>
        buildCategoryPageLink(item.redirectTo),
      );
    }

    const [globalSettings, adScripts] = await Promise.all([
      queryClient.fetchQuery('global', async () => fetchGlobal()),
      queryClient.fetchQuery('ad-scripts', () => fetchAdScripts({ is_active: true })),
      queryClient.prefetchQuery(['category-articles-count', category.slug], () =>
        fetchCategoryArticlesCount(category.slug),
      ),
      queryClient.prefetchInfiniteQuery(['articles-category', category.slug], () =>
        fetchCategoryArticles(category.slug, 0),
      ),
    ]);

    const seo = buildResourceSeoSettings(
      {
        ...globalSettings.global.seo,
        siteName: globalSettings.global.siteName,
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      getResourceSeo(category.category.seo),
    );

    return {
      props: {
        dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
        seo,
        slug: category.slug,
        type: 'categories',
        adScripts,
        globalSettings,
      },
      revalidate: 600,
    };
  } catch (e) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }
};


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[slug]/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  